<template>
    <div class="container container-main-noticies">
        <div class="row" v-if="main">
            <div class="col-12">
                <SuperLink 
                    v-if="main && main.link"
                    class="main-noticies__top main-noticies__top--first main-noticies__top--larger" 
                    :href="main.link"
                    target="_self">
                    <p class="noticies__title noticies__title--blue"><strong>{{main.title}}</strong></p>
                </SuperLink>
            </div>
        </div>

        <div class="row row__primary-block">
            <div class="col-12 col-md-9">
                <Carousel 
                    :slider="slider" 
                    width="832" 
                    height="328"
                    css_class="main-banner--index-4" />
            </div>
            <div class="col-12 col-md-3" v-if="simple">
                <Tabs>
                    <SuperLink v-if="simple && simple.link" :href="simple.link" target="_self" class="noticies-item noticies-item__tab">
                        <p class="noticies__label" v-if="simple.hat"><strong>{{simple.hat}}</strong></p>
                        <p class="noticies__label" v-else-if="simple.link && simple.link.editorial"><strong>{{simple.link.editorial.title}}</strong></p>
                        <p class="noticies__title noticies__title--blue noticies__title--small"><strong>{{simple.title}}</strong></p>
                    </SuperLink>
                </Tabs>
            </div>
        </div>
    </div>
</template>

<script>
import Carousel from '@/components/home/header/Carousel'
import Tabs from '@/components/home/header/Tabs'
import SuperLink from '@/components/SuperLink'

export default {
    name: 'Header04',
    props:['main', 'slider', 'simple'],
    components:{Carousel, Tabs, SuperLink}
}
</script>